import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { menuActions } from '@src/store/reducers/menuReducer';

export const createMenuMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [menuActions.GET_MENU]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}menus`);
            const list = response.data;
            next({ type: menuActions.SET_MENU, payload: list });
            return list;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/menu.middleware.ts